import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DevicesStore, InstallationFeaturesStore, RichDevice } from '../../../@store';
import { filter, takeUntil } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import moment from 'moment';
import { FeatureCommands, FeatureNames, FeaturePropertyKey } from '../../../../projects/client';

@Component({
  selector: 'app-edit-device-time',
  templateUrl: './edit-device-time.component.html',
  styleUrls: ['./edit-device-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditDeviceTimeComponent implements OnInit, OnDestroy {
  @Input() device: RichDevice;

  dateForm: FormGroup<{
    date: FormControl<Date>;
    time: FormControl<string>;
  }>;
  setTimeEnabled: boolean;

  private ngUnsubscribe$: Subject<void> = new Subject();

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private devicesStore: DevicesStore
  ) {}

  ngOnInit(): void {
    this.devicesStore.selectedDevice$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((selectedDevice) => {
        this.device = this.device ? this.device : selectedDevice;
      });

    this.installationFeaturesStore
      .getOffsetDeviceTime()
      .pipe(
        filter((val) => !!val),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((date) => {
        if (!this.dateForm) {
          this.initDateForm();
        }

        this.updateDateForm(date);
      });

    this.devicesStore.isHeatingDeviceTimeAvailable$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isAvailable: boolean) => {
        if (isAvailable) {
          this.setTimeEnabled = isAvailable;
        }
      });
  }

  saveDateAndTime(): void {
    const dateFormValue = this.dateForm.getRawValue();
    const dateFormDate = moment(dateFormValue.date).format('YYYY-MM-DD');

    let dateFormTime = dateFormValue.time.split(':');
    let newHours = dateFormTime[0].length === 1 ? `0${dateFormTime[0]}` : dateFormTime[0];
    let newMinutes = dateFormTime[1].length === 1 ? `0${dateFormTime[1]}` : dateFormTime[1];

    const newValue = `${dateFormDate}T${newHours}:${newMinutes}:00`;
    this.installationFeaturesStore.updateFeature(
      FeatureNames.heatingDeviceTime,
      newValue,
      FeaturePropertyKey.value,
      '',
      FeatureCommands.setTime,
      null,
      this.device?.id
    );
  }

  private initDateForm(): void {
    this.dateForm = new FormGroup({
      date: new FormControl<Date>(null),
      time: new FormControl<string>(null),
    });
  }

  private updateDateForm(date: Date): void {
    const hours = ('0' + date.getUTCHours()).slice(-2);
    const minutes = ('0' + date.getUTCMinutes()).slice(-2);

    this.dateForm.patchValue({
      date,
      time: `${hours}:${minutes}`,
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
